import React from 'react';
import PropTypes from 'prop-types';
import { getMediaImageUrl } from 'client/utils/image-helpers';

import './inline-article.scss';

export function InlineArticle({ content }) {
  return (
    <div className="inline-article d-flex">
      {content.image && (
        <img
          alt={content.title}
          className="inline-article-image mt-0_5 mt-md-0_25"
          src={getMediaImageUrl(content.image)}
        />
      )}
      <div className="ps-0_5 ps-md-1">
        <span className="h7 text-primary-darker fw-bold">{content.heading}</span>
        <a className="inline-article-title h5 d-block text-gray-darker mb-0" href={content.url}>
          {content.title}
        </a>
        <span className="h7 hidden-md-down">{content.text}</span>
        <a
          className="d-block h7 inline-article-link mt-0_25"
          href={content.url}
          data-tracking-id="inline_article_view_content"
          data-tracking-value={`${content.title} - inline`}
        >
          {content.ctaText}
        </a>
      </div>
    </div>
  );
}

InlineArticle.propTypes = {
  content: PropTypes.shape({
    heading: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    ctaText: PropTypes.string.isRequired,
  }).isRequired,
};
